/* rein-card-extras — MEGA F 2026-09-28. See snippets/rein-card-extras.liquid.
 *
 * Paints every "Arrives" line on product cards from window.ReinDelivery.windowFor()
 * (assets/rein-delivery-estimate.js — the product page's own function and ranges),
 * and asks Affirm to render any new "affirm-as-low-as" elements.
 *
 * Cards arrive late in many ways: AJAX filter/sort (facets.js renderPage), "load more",
 * product recommendations fetched after load, recently-viewed, marquee clones. One
 * MutationObserver catches all of them; work is batched to one pass per frame.
 * Affirm: affirm.ui.refresh() is Affirm's documented call for re-rendering
 * promotional messaging after the DOM changes. affirm.js itself is loaded by the
 * Affirm app embed; if it is absent nothing Affirm-related happens here.
 */
(function () {
  'use strict';
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function fmt(isoKey) {           // "2026-10-05" -> "Oct 5"
    var p = isoKey.split('-');
    return MONTHS[+p[1] - 1] + ' ' + (+p[2]);
  }

  function paintEta(root) {
    if (!window.ReinDelivery || !window.ReinDelivery.windowFor) return false;
    var els = (root || document).querySelectorAll('[data-rein-card-eta]:not([data-painted])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var w = window.ReinDelivery.windowFor(el.getAttribute('data-vendor'));
      el.setAttribute('data-painted', '');
      if (!w) { el.style.visibility = 'hidden'; continue; }
      el.textContent = 'Arrives ' + fmt(w.earliest) + ' – ' + fmt(w.latest);
      el.setAttribute('data-earliest', w.earliest);
      el.setAttribute('data-latest', w.latest);
    }
    return true;
  }

  var affirmTimer = null;
  function refreshAffirm() {
    if (!document.querySelector('.affirm-as-low-as')) return;
    clearTimeout(affirmTimer);
    affirmTimer = setTimeout(function () {
      if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function') {
        window.affirm.ui.ready(function () { window.affirm.ui.refresh(); });
      }
    }, 120);
  }

  var queued = false;
  function run() {
    queued = false;
    if (!paintEta(document)) setTimeout(run, 150);   // delivery script not parsed yet
    refreshAffirm();
  }
  function queue() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(run);
  }

  function start() {
    run();
    if ('MutationObserver' in window) {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var n = list[i].addedNodes;
          for (var j = 0; j < n.length; j++) {
            var el = n[j];
            if (el.nodeType === 1 && (el.matches('[data-rein-card-eta], .affirm-as-low-as') || el.querySelector('[data-rein-card-eta], .affirm-as-low-as'))) {
              queue(); return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('collection:product-filters', queue);
  }

  window.ReinCardExtras = { refresh: queue };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
